import { render, staticRenderFns } from "./controlRange.vue?vue&type=template&id=8c12d0b6&scoped=true"
import script from "./controlRange.vue?vue&type=script&lang=js"
export * from "./controlRange.vue?vue&type=script&lang=js"
import style0 from "./controlRange.vue?vue&type=style&index=0&id=8c12d0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c12d0b6",
  null
  
)

export default component.exports